<template>
  <div>
    <div class="row justify-content-end mb-3">

      <div class="col-auto">
        <button @click="refresh()" class="btn btn-secondary">
          <i class="bi bi-arrow-clockwise"></i> Actualiser
        </button>
      </div>
      <div class="col-auto">
        <button @click="print()" class="btn btn-secondary">
          <i class="bi bi-printer"></i> Imprimer
        </button>
      </div>
      <div class="col-auto">
        <button @click="printSelected(selections)" class="btn btn-secondary" :disabled="selections.length === 0">
          <i class="bi bi-printer"></i> Imprimer Sélectionné
        </button>
      </div>
    </div>

    <vue-data-table :headers="headers" :data="credits" :items-per-page="10" :buttons="buttons"
      :summable-columns="summableColumns">
      <!-- Customer Reference -->
      <template #cell-reference="{ row }">
        <input type="checkbox" class="form-check-input me-2" :value="row.reference" v-model="selections" />
        {{ row.reference }}
      </template>

      <!-- Customer Name -->
      <template #cell-customerFullName="{ row }">
        <span v-if="row.customer">{{ row.customer.fullName }}</span>
      </template>

      <!-- Total Unpaid -->
      <template #cell-totalUnpaid="{ row }">
        <span class="badge bg-danger">
          {{ parseFloat(row.totalUnpaid).toFixed(2) | formatWithSpaces }}
        </span>
      </template>

      <!-- Credit Status -->
      <template #cell-creditStatus="{ row }">
        <div v-if="row.customer && row.customer.maxUnpaid > 0" class="d-flex align-items-center">
          <input type="range" class="form-range" :min="0" :max="row.customer.maxUnpaid" :value="row.totalUnpaid"
            disabled :class="{
              'is-invalid': row.totalUnpaid >= row.customer.maxUnpaid
            }" style="width: 150px;" />
          <small class="ms-2">
            {{ parseFloat(row.totalUnpaid).toFixed(2) }} / {{ parseFloat(row.customer.maxUnpaid).toFixed(2) }}
          </small>
        </div>
      </template>

      <!-- Total TTC -->
      <template #cell-totalTTC="{ row }">
        <span class="badge bg-primary">
          {{ parseFloat(row.totalTTC).toFixed(2) | formatWithSpaces }}
        </span>
      </template>


    </vue-data-table>


  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      selections: [],
      headers: [
        { field: "reference", label: "Référence", },
        { field: "customerFullName", label: "Nom Complet", },
        { field: "totalUnpaid", label: "Total Impayé", class: "text-end", },
        { field: "creditStatus", label: "État de crédit" },
        { field: "totalTTC", label: "Total TTC", class: "text-end", },
        { field: "firstDate", label: "Du", },
        { field: "lastDate", label: "Au", },
      ],
      buttons: [
        {
          label: "Détails",
          icon: "bi bi-eye",
          class: "btn-outline-primary",
          action: (row) => this.viewDetails(row),
        }
      ],
      summableColumns: ["totalUnpaid", "totalTTC"]
    };
  },
  computed: {
    ...mapGetters("credit", {
      credits: "getCredits",
      
    }),
  },
  mounted() {
    this.$store.dispatch("credit/getAll");
  },
  methods: {
    async search(value) {
      await this.$store.dispatch("credit/search", value);
    },
    async refresh() {
      await this.$store.dispatch("credit/getAll");
      this.selections = [];
    },
    async print() {
      await this.$store.dispatch("credit/printAll");
    },
    async printSelected(data) {
      await this.$store.dispatch("credit/printAllSelected", data);
    },

    viewDetails(row) {
      this.$router.push({
        name: "reports-customers-index",
        query: {
          customer_reference: row.reference,
          startDate: row.firstDate,
          endtDate: row.lastDate,
        }
      })
    }
  },
  filters: {
    formatWithSpaces(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
};
</script>

<style scoped>
.form-range.is-invalid {
  color: #dc3545;
}

.form-range.is-invalid::-webkit-slider-thumb {
  background: #dc3545;
}

.form-range.is-invalid::-moz-range-thumb {
  background: #dc3545;
}

.form-range.is-invalid::-ms-thumb {
  background: #dc3545;
}
</style>